import { PlaybackState, usePlaylistStateStore, } from '@annunciate/core';
import { usePlaybackStateStore, getUUID, getRequestedContent, FileType, } from '@annunciate/core';
import { ensureDownload, getDownloadOrDefault } from '@annunciate/download';
import { onPlayNewAudio } from '../audio';
import { onPlayNewVideo } from '../video';
import { onOpenExternalLink } from '../other';
const promoteAvailablePlaylist = usePlaylistStateStore.getState().promoteAvailablePlaylist;
export const onRefetch = async (client, { content, initialPosition, } = {}) => {
    const { getState } = usePlaybackStateStore.getState();
    if (!content) {
        return;
    }
    const isStopped = getState(content.id) === PlaybackState.STOPPED;
    let { content: requestedContent, type, } = getRequestedContent(content);
    if (!requestedContent) {
        console.warn('No content to play');
        return;
    }
    if (!usePlaylistStateStore.getState().sessionId) {
        await promoteAvailablePlaylist(requestedContent);
    }
    const uuid = (await getUUID(true));
    const download = await getDownloadOrDefault(client, uuid, requestedContent);
    const isDownloaded = download.isDownloaded;
    requestedContent = download.content;
    let updateContent = requestedContent;
    switch (type) {
        case FileType.AUDIO:
            console.log("onRefetch audio");
            if (isDownloaded) {
                updateContent = download.content;
                break;
            }
            updateContent = await onPlayNewAudio({
                client,
                content: requestedContent,
                initialPosition,
                playOnLoad: !isStopped,
            });
            break;
        case FileType.EBOOK:
            if (!isDownloaded) {
                updateContent = await ensureDownload(client, uuid, requestedContent);
            }
            break;
        case FileType.VIDEO:
            updateContent = await onPlayNewVideo(client, requestedContent);
            break;
        case FileType.OTHER:
        case FileType.IMAGE:
        default:
            await onOpenExternalLink(client, requestedContent);
            break;
    }
    usePlaybackStateStore.setState({
        content: updateContent,
    });
};
//# sourceMappingURL=onRefetch.js.map